import { useContext, useState, useEffect } from "react";
import FrontpageService from "../services/FrontpageService";
import SiteContext from "../store/siteContext";
import ContentBlock1 from "../components/frontpage/content-blocks/ContentBlock1";
import DividerLine from "../components/frontpage/content-blocks/DividerLine";
import ContentBlockWrapper from "../components/frontpage/ContentBlockWrapper";
import AdvertBlock6 from "../components/frontpage/content-blocks/AdvertBlock6";

export default function Frontpage({ propFrontpage, reFetchOnNavigation=false }) {
	let { frontpageContent, setFrontpageContent, categories } = useContext(SiteContext);
	const [loading, setLoading] = useState(!frontpageContent); // Track loading state only if no content is available
	const [loadingNew, setLoadingNew] = useState(false);

	// Fetch the frontpage on every visit
	useEffect(() => {
		if (propFrontpage === undefined) {
			// Only fetch if reFetchOnNavigation is true or content is missing
			if (!loadingNew && (reFetchOnNavigation || !frontpageContent)) {
				fetchFrontpage();
			}
		} else {
			// Only set if propFrontpage is provided (not undefined)
			setFrontpageContent(propFrontpage);
			setLoading(false);
		}
	}, [propFrontpage, reFetchOnNavigation]);


	const fetchFrontpage = async () => {
		setLoadingNew(true)
		const newFrontpage = await FrontpageService.getFrontpageWithContent();

		// Only update if the new frontpage is different from the old
		if (!frontpageContent ||
			(frontpageContent && (newFrontpage.version !== frontpageContent.version))) {
				setFrontpageContent(null);
				setFrontpageContent(newFrontpage); // Update the context
		}

		setLoadingNew(false);
		setLoading(false);
	};

	//document.title = "Båtens Verden";

	// Show loading state while the frontpage is being fetched
	if (loading || !frontpageContent) {
		return (
			<div inert="true" className={'frontpage isLoading animationShine'} style={{ userSelect: 'none', pointerEvents: 'none', opacity: '40%' }}>
				<AdvertBlock6 />
				<DividerLine customStyle={{ color: 'rgb(255, 255, 255)', paddingTop: '13px', paddingBottom: '13px' }} />
				<section>
					<ContentBlockWrapper>
						<div className={'advertBlock6 contentBlock'}>
							<div className={'advertBlock6Image'} style={{ background: '#d3d3d3', aspectRatio: '7.29/1' }}></div>
						</div>
					</ContentBlockWrapper>
				</section>
				<DividerLine customStyle={{ color: 'rgb(255, 255, 255)', paddingTop: '13px', paddingBottom: '13px' }} />
				<section>
					<ContentBlock1 customStyle={{ color: '#d3d3d3', wordBreak: 'break-word' }} parts={[{ name: '───────────────' }, { name: '───────────────' }, { name: '──────────────────────────────' }]} />
				</section>
			</div>
		);
	}

	// Render the frontpage when the content is available
	return (
		<div className={'frontpage'}>
			{FrontpageService.FrontpageRender({
				frontpageModules: frontpageContent.modules,
				isLive: true,
				categories: categories
			})}
		</div>
	);
}
